import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const getAllCsUsers = createAsyncThunk(
	'csUsers/getAllCsUsers',
	async () => {
	  console.log('getAllCsUsers params');

	  const response = await api.get(
	  `cs_user/all`,
	  {
		timeout: 30000,
	  });
	  console.log('getAllCsUsers response', response.data);
	  return response.data;
	}
);

export const updateCsUser = createAsyncThunk(
  'csUsers/updateCsUser',
  async (params: { userId: string; firstName: string, lastName:string, telephone:string }) => {
    const { userId, firstName, lastName, telephone } = params;
    await api.put(`/cs_user/${userId}`, {
      firstName,
      lastName,
      telephone
    });
    return {
      userId,
    };
  }
);

export const deleteCsUser = createAsyncThunk(
  'csUsers/deleteCsUser',
  async (params: { userId: string; deletedBy: string}) => {
    const { userId, deletedBy } = params;
    await api.delete(`/cs_user/${userId}`, {
      data: {
        deletedBy
      }
    });
    return {
      userId,
    };
  }
);

const initialState: {
    status: string;
    error: string;
    data: any;
} = {
    status: '',
    error: '',
    data: {},
};

const csUsersSlice = createSlice({
    name: 'csUsers',
    initialState: initialState,
    reducers: {
        csUsersSliceClean(state, action) {
          console.log('csUsersSliceClean', action);
          state.data.loading = false;
          state.data.complete = false;
          state.data.error = '';
          state.data.updateLoading = false;
          state.data.updateComplete = false;
          state.data.deleteLoading = false;
          state.data.deleteComplete = false;
      },
    },
    extraReducers: (builder) => {
        //getClass
        builder.addCase(getAllCsUsers.pending, (state) => {
          state.data.loading = true;
          state.data.complete = false;
          state.data.error = '';
        });
        builder.addCase(getAllCsUsers.fulfilled, (state, action) => {
          state.data.loading = false;
          state.data.complete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(getAllCsUsers.rejected, (state, action) => {
          state.data.loading = false;
          state.data.complete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });
        
        //updateCsUser
        builder.addCase(updateCsUser.pending, (state) => {
          state.data.updateLoading = true;
          state.data.updateComplete = false;
          state.data.error = '';
        });
        builder.addCase(updateCsUser.fulfilled, (state, action) => {
          state.data.updateLoading = false;
          state.data.updateComplete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(updateCsUser.rejected, (state, action) => {
          state.data.updateLoading = false;
          state.data.updateComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });

        builder.addCase(deleteCsUser.pending, (state) => {
          state.data.deleteLoading = true;
          state.data.deleteComplete = false;
          state.data.error = '';
        });
        builder.addCase(deleteCsUser.fulfilled, (state, action) => {
          state.data.deleteLoading = false;
          state.data.deleteComplete = true;
          state.data = Object.assign(state.data, action.payload);
        });
        builder.addCase(deleteCsUser.rejected, (state, action) => {
          state.data.deleteLoading = false;
          state.data.deleteComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
        });
    },
  });
  
  export const { csUsersSliceClean } = csUsersSlice.actions;
  export default csUsersSlice;